import {MAIN, NAMESPACE} from '../../constant';

/**
 * Export SESSION_STORAGE_KEY
 */
export const SESSION_STORAGE_KEY = `glasfaser`;

/**
 * Export COOKIE_KEY
 */
export const COOKIE_KEY = `glasfaser`;

/**
 * Export GET_INITIAL_STATE
 */
export const GET_INITIAL_STATE = `${NAMESPACE}/GET_INITIAL_STATE`;

/**
 * Export SET_INITIAL_STATE
 */
export const SET_INITIAL_STATE = `${NAMESPACE}/SET_INITIAL_STATE`;

/**
 * Export SAVE_CONTRACT_DATA_VALUES
 */
export const SAVE_FORM_DATA_VALUES = `${NAMESPACE}/SAVE_FORM_DATA_VALUES`;

/**
 * GLASFASER_API_URL
 */
export const GLASFASER_API_URL = '/api/vfd2dyn/json/glasfaser/checkAddress.php';

/**
 * Export HANDLE_VALID_API_RESPONSE
 */
export const HANDLE_VALID_API_RESPONSE = `${NAMESPACE}/HANDLE_VALID_API_RESPONSE`;

/**
 * Export HANDLE_INVALID_API_RESPONSE
 */
export const HANDLE_INVALID_API_RESPONSE = `${NAMESPACE}/HANDLE_INVALID_API_RESPONSE`;

/**
 * Export GET_ADDRESS Actionname
 */
export const GET_ADDRESS = `${NAMESPACE}/GET_ADDRESS`;
/**
 * Export GET_ADDRESS_SUCCESS Actionname
 */
export const GET_ADDRESS_SUCCESS = `${NAMESPACE}/GET_ADDRESS_SUCCESS`;
/**
 * Export GET_ADDRESS_FAILED Actionname
 */
export const GET_ADDRESS_FAILED = `${NAMESPACE}/GET_ADDRESS_FAILED`;

/**
 * Export INIT_ADDRESS_FORM Actionname
 */
export const INIT_ADDRESS_FORM = `${NAMESPACE}/INIT_ADDRESS_FORM`;

/**
 * Export INIT_ADDRESS_FORM Actionname
 */
export const INIT_APP = `${NAMESPACE}/INIT_APP`;

/**
 * Export TRACK_INITIAL_PAGE_VIEW
 */
export const TRACK_AVAILABILITY_CHECK = `${NAMESPACE}/TRACK_AVAILABILITY_CHECK`;

/**
 * Export GET_ADDRESS Actionname
 */
export const TRACK_INIT = `${NAMESPACE}/TRACK_INIT`;
